<template>
    <section class='main'>
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item prop='dictType' style='margin-bottom: 0'>
                                <el-input
                                    size='mini'
                                    v-model='queryParams.mapId'
                                    clearable
                                    placeholder='请输入地图id'
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select size='mini' clearable v-model='queryParams.showState' placeholder='请选择审核状态'>
                                    <el-option
                                        v-for='item in mapStatus'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-row class='mb8'>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-plus'
                                    plain
                                    size='mini'
                                    type='primary'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='mapInfoList'
                      @selection-change='handleSelectionChange'>
                <el-table-column align='center' label='地图Id' prop='mapId' />
                <el-table-column align='center' >
                    <template slot-scope="scope">
                        <el-image
                            fit='scale-down'
                            v-if='scope.row.thumbnail'
                            style="width: 100px; height: 100px"
                            :preview-src-list='[scope.row.thumbnail]'
                            :src="scope.row.thumbnail"></el-image>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='地图标题' prop='mapTitle' />
                <el-table-column align='center' label='地图描述' prop='mapDesc' />
                <el-table-column label='审核'>
                    <template slot-scope="scope">
                        <el-button type="text" v-if='scope.row.showState === 3 || scope.row.showState === 4' size='mini' @click='auditMap(scope.row, 0)'>通过</el-button>
                        <el-button type="text" v-if='scope.row.showState === 0 || scope.row.showState === 3' size='mini' @click='auditMap(scope.row, 4)' style='color: #F56C6C'>不通过</el-button>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='最后更新时间' prop='updateTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            v-if='scope.row.showState !== 1 && scope.row.showState !== 2'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                        <el-button
                            size='mini'
                            type='text'
                            v-if='scope.row.showState === 2'
                            @click='recoveryDelete(scope.row)'
                        >恢复
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog title='审核' :before-close='cancel' :visible.sync='open' append-to-body width='40%'>
                <el-input type='textarea' size='mini'
                          v-if='currentData.showState === 4'
                          v-model='currentData.auditFailureReason'
                          :autosize="{ minRows: 2, maxRows: 4}" placeholder='请输入审核失败原因'/>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>提 交</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
            
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deleteWhiteUrl } from '@/components/api/white';
import { deepCopy } from '@/utils/object';
import CottonFileUpload from '@/components/component/CottonFileUpload.vue';
import CottonDynamicForm from '@/components/component/CottonDynamicForm.vue';
import { lilliputApi } from '@api/lilliput';

export default {
    name: 'Lilliput',
    components: { CottonDynamicForm, CottonFileUpload },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                showState: 3,
                mapId: undefined
            },
            updateStatus: false,
            mapStatus: [
                {
                    label: '审核通过',
                    value: 0
                },
                {
                    label: '管理员删除',
                    value: 2
                },
                {
                    label: '待审核',
                    value: 3
                },
                {
                    label: '未通过审核',
                    value: 4
                },
            ],
            
            mapInfoList: [],
            currentData: {
                icon: undefined,
                copyrightMsg: undefined
            },
            projectFileInfo: {
                ownerType: 'GAME_PROJECT',
                accessType: 'PUBLIC',
                saveFolder: '/project/icon'
            },
            projectIcon: undefined,
            openAuditDialogVisible: false
        };
    },
    watch: {
        treeFilterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    computed: {
    
    },
    created() {
        this.getList();
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            lilliputApi.query(this.queryParams).then(response => {
                    if (response.code === 200) {
                        this.mapInfoList = response.data.result;
                        this.queryParams.total = response.data.total;
                        this.loading = false;
                        this.queryParams.pageNum = response.data.pageNum;
                    } else {
                        this.loading = false;
                    }
                }
            );
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.projectIcon = undefined
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                showState: 3
            };
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = '增加后端接口';
            this.updateStatus = false;
            this.currentProjectInfo = {
                icon: undefined,
                copyrightMsg: undefined
            };
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            this.$modal.confirm(`是否删除 ${idList.length} 条数据?`).then(function() {
                return deleteWhiteUrl(idList);
            }).then(result => {
                if (result.code === 200) {
                    message.success('删除成功');
                    obj.getList();
                    return;
                }
            });
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            this.open = true;
            this.title = '审核地图';
            this.updateStatus = true;
            this.currentData = deepCopy(row);
        },
        /** 提交按钮 */
        submitForm: function() {
            if (this.updateStatus) {
                lilliputApi.update(this.currentData).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.mapId + '"地图？').then(function() {
                return lilliputApi.update({mapId: row.mapId, showState: 2});
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        recoveryDelete(row) {
            this.$modal.confirm('是否恢复"' + row.mapId + '"地图, 地图恢复后，需要重新审核').then(function() {
                return lilliputApi.update({mapId: row.mapId, showState: 3});
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('恢复成功');
                }
            }).catch(() => {
            });
        },
        handleFileUploadSuccess(file) {
            this.projectIcon = file.url
        },
        
        getDynamicJsonString(setting) {
            this.currentProjectInfo.copyrightMsg = setting
        },
        auditMap(row, showState) {
            this.reset();
            this.open = true;
            this.title = '审核地图';
            this.updateStatus = true;
            this.currentData = deepCopy(row);
            this.currentData.showState = showState
        },
    }
};
</script>
<style>

</style>